import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  fullscreen: {
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  ldlWrapper: {
    backgroundColor: Theme.blackPearlBlack,
    bottom: 0,
    height: Theme.px(102),
    overflow: 'hidden',
    position: 'absolute',
    width: Theme.appWidth,
  },
  radialGradientBackgroundContainer: {
    height: '100%',
  },
});
